import React, { useState } from 'react'
import { Button } from '@mui/material'
import RequestDialog from '../../dialogs/RequestDialog'
import '../../../styles/pages.css'
import { useWithErrorNotification } from 'shared/ui/GlobalDialog'
import { makeKiddomDeleteRequest } from 'infrastructure/api'

function PurgeDistrictSISDataButton({
  districtName,
  districtID,
}: {
  districtName: string
  districtID: number
}) {
  const deleteRequest = useWithErrorNotification(
    { errorTitle: 'Error Purging' },
    makeKiddomDeleteRequest,
  )
  const [open, setOpen] = useState(false)
  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const PurgeDistrictSISData = async () => {
    const kiddomPath = `/v1/district/${districtID}/sis/purge`
    await deleteRequest({ kiddomPath })
  }

  return (
    <div className="section-buttons">
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Purge all district sis data
      </Button>
      <RequestDialog
        open={open}
        title="Are you sure you want to purge all district sis data?"
        content={[
          { key: 'District name', value: districtName },
          { key: 'District ID', value: String(districtID) },
        ]}
        submitRequest={PurgeDistrictSISData}
        waitingTime={2000}
        onClose={handleClose}
      />
    </div>
  )
}
export default PurgeDistrictSISDataButton
